module.exports = __webpack_public_path__ + "static/media/chiefAccountant-4.e8293f6c.png";